<ng-template
  *ngIf="vars.fundraiser?.cause_id === 59 && vars.fundraiser?.parent_cause_id === 20 && !cartDetails?.recurring && (vars.supportFee > 0 || cartDetails?.supportFee > 0)"
  [ngTemplateOutlet]="supportFeeTemplate" />
<div *ngIf="showOptions" class="option-container">
  <div *ngIf="!options?.length" class="place-holder"></div>
  <div *ngIf="options?.length>1 && !isMobile" class="options">
    <div *ngFor="let option of options">
      <button *ngIf="option" class="option-tab" type="button" (click)="setOptionRoute(option)"
        [class.is-active]="activeButton==option.route" [disabled]="optionsDisble || vars.isOrderLoading"
        mat-stroked-button>
        <span><i class="{{option?.icon}}"></i></span> <span class="option-name">{{option?.name}}</span>
      </button>
    </div>
  </div>

  <div class="routes" *ngIf="!isMobile">
    <ng-template *ngIf="pCurrency!=='INR'" [ngTemplateOutlet]="stripeLink" />
    <app-netbanking [option]="paymentOptions?.options?.NB" [topBank]="paymentOptions?.options?.TOPNB"
      [hidden]="!(activeButton=='nb')" [cartDetails]="cartDetails" (dataEmit)="submitOrder($event)"
      [isOrderLoading]="isOrderLoading">
    </app-netbanking>
    <app-cards [cartDetails]="cartDetails" [option]="paymentOptions?.options?.CARD" [hidden]="!(activeButton=='c')"
      (dataEmit)="submitOrder($event)" [isOrderLoading]="isOrderLoading" [currency]="pCurrency"
      [showZip]="pCurrency !=='INR'?true:false">
    </app-cards>
    <app-paytm [option]="paymentOptions?.options?.PAYTM" [hidden]="!(activeButton=='p')" [cartDetails]="cartDetails"
      (dataEmit)="submitOrder($event)" [qrCodeUrl]="qrCodes?.paytm" [isOrderLoading]="isOrderLoading">
    </app-paytm>
    <app-wallets [option]="paymentOptions?.options?.WALLET" [hidden]="!(activeButton=='w')" [cartDetails]="cartDetails"
      (dataEmit)="submitOrder($event)" [isOrderLoading]="isOrderLoading"
      [topWallets]="paymentOptions?.options?.TOPWALLET">
    </app-wallets>
    <app-upi *ngIf="paymentOptions?.options?.UPI" [option]="paymentOptions?.options" [cartDetails]="cartDetails"
      [isOrderLoading]="isOrderLoading" [qrURL]="qrCodes?.upi" [campaignId]="campaignId" [origin]="origin"
      [customTag]="customTag" [hidden]="!(activeButton=='u')" (dataEmit)="submitOrder($event)"
      (disableOptions)="disableOptions($event)" (cardDetailsEmit)="cartDetails=$event"></app-upi>
  </div>

  <!--for Mobile-->
  <div *ngIf="isMobile" class="options">
    <ng-template *ngIf="pCurrency!=='INR'" [ngTemplateOutlet]="stripeLink" />
    <app-cards [option]="paymentOptions?.options?.CARD" [hidden]="!(optionRoute.op=='c')"
      (dataEmit)="submitOrder($event)" [isOrderLoading]="isOrderLoading" [currency]="pCurrency"
      [showZip]="pCurrency !=='INR'?true:false">
    </app-cards>
    <app-paytm [option]="paymentOptions?.options?.PAYTM" [hidden]="!(optionRoute.op=='p')" [cartDetails]="cartDetails"
      (dataEmit)="submitOrder($event)" [isOrderLoading]="isOrderLoading">
    </app-paytm>
    <app-upi *ngIf="paymentOptions?.options?.UPI" [option]="paymentOptions?.options" [hidden]="!(optionRoute.op=='u')"
      [cartDetails]="cartDetails" [isOrderLoading]="isOrderLoading" [qrURL]="qrCodes?.upi" [campaignId]="campaignId"
      [origin]="origin" [customTag]="customTag" (dataEmit)="submitOrder($event)"
      (disableOptions)="disableOptions($event)"></app-upi>
  </div>

  <div *ngIf="isMobile && !optionRoute.op" [class.prevent-click]="vars.isOrderLoading">

    <!-- All UPI options -->

    <!-- previus used upi -->
    <div *ngIf="!paymentOptions?.options?.vpa_collect_enabled && paymentOptions?.options?.PREVIOUSPAYMENTGATEWAY && prevUsedUpi" class="cards">
      <div class="heading" [class.mt-0]="vars.askTipOnPayOpt">
        <h2>Previously Used</h2>
      </div>
      <div class="previously-upi">
        <div class="upi-item">
          <div class="upi-left">
            <img src="{{vars.upiImages[prevUsedUpi]}}" [alt]="prevUsedUpi" />
            <span class="upi-name">{{prevUsedUpi}}</span>
          </div>
          <div class="upi-radio">
            <div class="cricle"></div>
          </div>
        </div>
        <app-donate-btn (click)="submitOrderMobile('UPI', prevUsedUpi)" label="Pay" [amount]="cartDetails?.donated_amount" [isOrderLoading]="isOrderLoading || vars.isOrderLoading"></app-donate-btn>
      </div>
    </div>

    <ng-container *ngIf="paymentOptions?.options?.UPI">
      <div class="new-option option-upi">
        <div class="head">
          <div class="left">
            <div class="title">UPI</div>
            <div *ngIf="!paymentOptions?.options?.vpa_collect_enabled" class="recommended" [class.AB]="vwo.payment_otd_AB()">RECOMMENDED</div>
          </div>
          <div class="right"><div class="view-all" (click)="goToInnerRoute('u', 'UPI')">View All UPI</div></div>
        </div>
        <div class="body-content" (click)="!vwo.payment_otd_AB() ? goToInnerRoute('u', 'UPI') : null">
          <div *ngIf="paymentOptions?.options?.TOPUPI" class="main-option">
            <ng-container *ngFor="let key of topUpiApps; let i=index">
              <ng-container *ngIf="paymentOptions?.options?.TOPUPI[key] && i<5">
                <div class="item {{key}}" [class.active]="isOrderLoading && submitOrderData?.mode_value === key">
                  <div class="icon" [class.blurBack]="vars.isOrderLoading && submitOrderData?.mode_value !== key" (click)="vwo.payment_otd_AB() ? submitOrderMobile('UPI', key) : null">
                    <div *ngIf="isOrderLoading && submitOrderData?.mode_value === key" class="dots-loader-v2" style="--size: 38px;"><span></span></div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <div class="veiw-all" (click)="vwo.payment_otd_AB() ? goToInnerRoute('u', 'UPI') : null" matRipple><app-icon [name]="vwo.payment_otd_AB() ? 'chevron_right' : 'arrow_forward_ios'" /></div>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="cards">
      <div class="heading" [class.mt-0]="vars.askTipOnPayOpt && !paymentOptions?.options?.UPI">
        <h2>DEBIT / CREDIT CARD</h2>
      </div>
      <div class="card-section CARDS" [class.prevent-click]="vars.isOrderLoading" [class.blurBack]="vars.isOrderLoading"
        (click)="goToInnerRoute('c', 'Debit/Credit')" matRipple>
        <img loading="lazy" data-src="/assets/images/story/Payment-Methods-icos.png" alt="Payment methods icons" />
        <app-icon *ngIf="vwo.payment_otd_AB()" name="chevron_right" />
        <i *ngIf="!vwo.payment_otd_AB()" class="material-icons">arrow_forward_ios</i>
      </div>
    </div>
    <!-- All banks -->
    <div *ngIf="paymentOptions?.options?.TOPNB" class="cards">
      <div class="heading">
        <h2>Netbanking</h2>
        <span>
          <a (click)="openSelectMenu(allBanks, 'Net Banking')">View All Banks</a>
        </span>
      </div>
      <div class="card-section text-center" [class.prevent-click]="vars.isOrderLoading" [class.blurBack]="vars.isOrderLoading">
        <div *ngFor="let key of getObjectKeys(paymentOptions?.options?.TOPNB)" (click)="submitOrderMobile('NB', key)"
          class="all-bank submit-payment">
          <div class="{{key}}" [class.loader-key]="isOrderLoading && submitOrderData?.mode_value === key" matRipple
            data-bg="/assets/images/payment/top-netbanking.png">
            <div *ngIf="isOrderLoading && submitOrderData?.mode_value === key" class="dots-loader-v2" style="--size: 49px"><span></span></div>
          </div>
          <span class="b-name">{{paymentOptions?.options?.TOPNB[key]}}</span>
        </div>
      </div>
    </div>

    <!-- All wallets -->
    <div *ngIf="paymentOptions?.options?.TOPWALLET" class="cards wallerts-container">
      <div class="heading">
        <h2>Wallets</h2>
        <span><a (click)="openSelectMenu(allWallet, 'Wallets')">View All Wallets</a></span>
      </div>
      <div class="card-section text-center" [class.prevent-click]="vars.isOrderLoading" [class.blurBack]="vars.isOrderLoading">
        <div *ngFor="let key of getObjectKeys(paymentOptions?.options?.TOPWALLET, 'wallet')"
          (click)="submitOrderMobile('WALLET', key)" class="all-bank submit-payment">
          <div class="{{key}}" [class.loader-key]="isOrderLoading && submitOrderData?.mode_value === key"
            matRipple>
            <div *ngIf="isOrderLoading && submitOrderData?.mode_value === key" class="dots-loader"><span></span></div>
          </div>
          <span class="b-name">{{paymentOptions?.options?.TOPWALLET[key]}}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<app-captcha size="invisible" (dataEmit)="gotCaptchaResponse($event)" />

<!-- options for listing bank -->
<ng-template #allBanks>
  <div class="list-dilaog">
    <div class="close">
      <button type="button" [class.visible-hide]="vars.isOrderLoading" (click)="location.back()"
        mat-icon-button><mat-icon>arrow_back</mat-icon> BACK</button>
    </div>
    <app-input class="search-input" inputType="text" [control]="searchText" [group]="searchForm" placeHolder="Search"
      (OnChange)="search($event)">
    </app-input>
    <mat-list>
      <div class="list-container bankDropdownList" *ngFor="let key of getObjectKeys(paymentOptions?.options?.NB)"
        mat-list-item>
        <button class="list-btn submit-payment" type="button" [disabled]="isOrderLoading"
          (click)="submitOrderMobile('NB', key)" mat-button>
          <span *ngIf="!(isOrderLoading && submitOrderData?.mode_value === key)">{{paymentOptions?.options?.NB[key]}}
            <mat-icon class="lits-icon">keyboard_arrow_right</mat-icon></span>
          <div *ngIf="isOrderLoading && submitOrderData?.mode_value === key" class="dots-loader"><span></span></div>
        </button>
      </div>
    </mat-list>
  </div>
</ng-template>

<!-- options for listing bank -->
<ng-template #allWallet>
  <div class="list-dilaog">
    <div class="close">
      <button type="button" [class.visible-hide]="vars.isOrderLoading" (click)="location.back()"
        mat-icon-button><mat-icon>arrow_back</mat-icon> BACK</button>
    </div>
    <mat-list>
      <div class="list-container" *ngFor="let key of getObjectKeys(paymentOptions?.options?.WALLET, 'wallet')"
        mat-list-item>
        <button class="list-btn submit-payment" type="button" (click)="submitOrderMobile('WALLET', key)" mat-button>
          <span
            *ngIf="!(isOrderLoading && submitOrderData?.mode_value === key)">{{paymentOptions?.options?.WALLET[key]}}
            <mat-icon class="lits-icon">keyboard_arrow_right</mat-icon></span>
          <div *ngIf="isOrderLoading && submitOrderData?.mode_value === key" class="dots-loader"><span></span></div>
        </button>
      </div>
    </mat-list>
  </div>
</ng-template>

<ng-template #supportFeeTemplate>
  <div class="sf-container">
    <div class="sf-details">
      <span class="title">
        Total Amount <span class="sf-total-amount" [innerHtml]="cartDetails?.currency|currencyIcon"></span>
        <span class="sf-total-amount">{{cartDetails?.donated_amount}}</span>
      </span>
      <span class="subtitle">
        Including fundraiser support fee <ng-template [ngTemplateOutlet]="infoIcon"
        [ngTemplateOutletContext]="{ tooltipMessage: 'Helps us keep our platform free for those who need to start fundraisers. It also covers the cost of verification, customer support, and technology that ensures contributions reach the people who need them most' }" />
      </span>
    </div>
  </div>
</ng-template>

<ng-template #stripeLink>
  <div *ngIf="isMobile && showStripeLink" class="sp-line"></div>
  <div *ngIf="payConfig?.optionsResponse" [hidden]="!showStripeLink" class="stripeLinkPay"
    [class.oneTapEnable]="showOneTapPay">
    <div class="actBtn">
      <app-stripe-express [amount]="cartDetails?.donated_amount||100" [currency]="cartDetails?.currency||'usd'"
        (availablePaymentMethods)="onStripeExpressReady($event)" (onCheckoutClick)="onStripeCheckoutClick($event)" />
    </div>
    <div class="orPay">
      <div class="line"></div>
      <div class="text">or pay with card</div>
      <div class="line"></div>
    </div>
  </div>
</ng-template>

<ng-template #infoIcon let-tooltipMessage="tooltipMessage">
  <div class="infoIcon" #tooltip="matTooltip" (click)="vars.isMobile ? tooltip.show() : ''"
    [matTooltip]="tooltipMessage">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M7 0.999998C3.68629 0.999997 1 3.68629 1 7C1 10.3137 3.68629 13 7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 0.999998 7 0.999998Z"
        stroke="#737373" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M7 9.3999L7 6.9999" stroke="#737373" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M7 4.6001L6.994 4.6001" stroke="#737373" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>
</ng-template>